import axios from "axios";
import requestId from "../utils/requestId";
import { addTokenRefreshInterceptor } from "./tokenInterceptor";

const axiosInstance = () => {
  const customAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    responseType: "json",
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 100000,
  });

  customAxios.interceptors.request.use((config) => {
    const publicEndpoints = [
      'auth/generate-otp',
      'auth/corporateUserLogin/',
      'auth/corporateUserAuthLogin/',
      'auth/consent/verify-otp-redirect',
      'auth/consent/exchange-token',
      'auth/mis-user-login',
      '/static/tc/privacy-policy/view',
      '/static/tc/latest/view',
      '/static/tc/eway-bill-consent/view',
      '/static/tc/latest/download'
    ]

    const isPublicEndpoint = publicEndpoints.some((endpoint) =>
      config?.url?.includes(endpoint)
    );

    if (!isPublicEndpoint) {
      // Add access token for API Gateway authorization
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers["Authorization"] = `${token}`;
      }

      // Add requestId and user token to request body
      if (config.data) {
        config.data["requestId"] = requestId();
        const userToken = localStorage.getItem("token");
        if (userToken) {
          config.data["token"] = userToken;
        }
      }
    } else if (config.data) {
      // For public endpoints, only add requestId
      config.data["requestId"] = requestId();
    }

    return config;
  });

  customAxios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response) {
        // Removed as it was conflixting with token refresh logic.
        // if (error.response.status === 401) {
        //   localStorage.removeItem('access_token')
        //   window.location.href = '/'
        // }
        return Promise.reject(error.response.data || "Something went wrong");
      }
      return Promise.reject(error.message || "Network error");
    }
  );
  // Added token refresher, as first the token was refreshed when page was mounted but not when it is being added on successfull login.
  addTokenRefreshInterceptor(customAxios);
  return customAxios;
};

export const axiosCatchErrorMsg = (error) => {
  switch (error.code) {
    case "ECONNABORTED":
      return "Connection Timeout, Please try again.";
    default:
      return error.message;
  }
};

export default axiosInstance;
